import styled, { css } from 'styled-components'
import Image from 'next/image'

import ActionButton from '../../ActionButton'
import Highlight from '../../Highlight'
import _Tag from '../../Tag'
import Icon from '../../Icon'

type ContainerProps = {
  isOpen: boolean
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndexes.modal};
  display: flex;
  flex-flow: column nowrap;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  ${({ theme, isOpen }) =>
    isOpen === true
      ? css`
          visibility: visible;
          opacity: 1;
          z-index: ${theme.zIndexes.modal};
          pointer-events: all;
        `
      : css`
          visibility: hidden;
          opacity: 0;
          pointer-events: none;
          z-index: -1;
        `}
`

export const Wrapper = styled.div`
  position: relative;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent ?? 5};
  flex: 1 1 auto;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
`

export const Close = styled.div`
  position: absolute;
  top: 0;
  top: 2.5rem;
  right: 1.5rem;
  z-index: ${({ theme }) => theme.zIndexes.modal};
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  & > * {
    flex: 0 0 auto;
  }
`

export const Content = styled.div`
  flex: 1 1 auto;
`

export const Slider = styled.div<{ isSliderReady: boolean }>`
  opacity: ${({ isSliderReady }) => (isSliderReady === true ? '1' : '0')};
  height: 100%;
`

export const Slide = styled.div`
  overflow: hidden;
  scrollbar-width: thin;
`

export const Controls = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => (theme.zIndexes.minimalContent ?? 5) + 1};
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 2.5rem 2rem 2rem;
`

export const Dot = styled.button<{ isActive: boolean; isInitial: boolean }>`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  overflow: hidden;
  color: transparent;
  background: ${({ theme, isInitial }) =>
    isInitial ? theme.colors.pureBlack : theme.colors.pureWhite};
  opacity: ${({ isActive }) => (isActive === true ? '1' : '0.3')};
  &:not(:first-child) {
    margin-left: 0.5rem;
  }
`

export const Dots = styled.div``

export const SliderArrow = styled(ActionButton)`
  &:disabled {
    color: ${({ theme }) => theme.colors.pureBlack};
    border-color: ${({ theme }) => theme.colors.pureWhite};
    background-color: ${({ theme }) => theme.colors.pureWhite};
    opacity: 0.5;
  }
  // added because the centering was making me crazy
  &:first-child {
    & > * {
      transform: translateX(-1px);
    }
  }
  &:last-child {
    & > * {
      transform: translateX(1px);
    }
  }
`

export const InitialSlide = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 1.6rem;

  @media (max-height: 800px) {
    gap: 1rem;
  }
`

export const Background = styled(Icon)`
  position: absolute;
  bottom: -20rem;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndexes.background};

  @media (max-height: 800px) {
    bottom: -18rem;
  }
`

export const MainImage = styled(Image)``

export const RecipeName = styled(Highlight)`
  ${({ theme }) => theme.textStyles.text_bold_condensed_20}
  font-size: 2rem;
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};

  @media (max-height: 800px) {
    margin-top: -4rem;
  }
`

export const Tag = styled(_Tag)`
  text-align: center;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  margin-top: 1rem;
`

export const Intro = styled.div`
  ${({ theme }) => theme.textStyles.text_16}
  color: ${({ theme }) => theme.colors.familyBurgundy};
  margin-top: 1.6rem;
  text-align: center;
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
`

export const SecondaryImage = styled.div`
  z-index: ${({ theme }) => theme.zIndexes.minimalContent};
  width: 240px;
  height: 180px;
  margin: 1rem auto 0 auto;
`
